import { IntlShape } from "react-intl";
import { subTopicSupport, typeSubjectOccorence, typesOcorrenceStatus } from "./constants";
import { getSupportSubtopicLabel } from "./getSupportSubtopicLabel";
import { OccurrenceStatus } from "./types";

const formatLabel = (intl: IntlShape, id: string, defaultMessage: string) =>
    intl.formatMessage({ id, defaultMessage });

export const getSupportStatusLabel = (intl: IntlShape, status?: OccurrenceStatus) => {
    if (!status) {
        return "-";
    }

    return formatLabel(
        intl,
        `intl-msg:tas.support.status.${status}`,
        typesOcorrenceStatus[status] ?? status,
    );
};

export const getSupportSubjectLabel = (intl: IntlShape, subject?: string) => {
    if (!subject) {
        return "-";
    }

    const normalized = subject.toUpperCase();
    const defaultMessage =
        typeSubjectOccorence[normalized as keyof typeof typeSubjectOccorence] ?? subject;

    return formatLabel(intl, `intl-msg:tas.support.subject.${normalized}`, defaultMessage);
};

export const getSupportSubtopicIntlLabel = (intl: IntlShape, subtopic?: string) => {
    if (!subtopic) {
        return "-";
    }

    const defaultMessage = getSupportSubtopicLabel(subtopic);

    if (defaultMessage === "-") {
        return "-";
    }

    return formatLabel(intl, `intl-msg:tas.support.subtopic.${subtopic}`, defaultMessage);
};
